import Vue from 'vue'
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import ChangePassword from './views/ChangePassword.vue';
import ResetPassword from './views/ResetPassword.vue';
import Dashboard from './views/Dashboard.vue';
import SubAdmins from './views/SubAdmins.vue';
import Layout from './views/Layout.vue';
import ManagePackages from './views/ManagePackages.vue';
import ManageBookings from './views/ManageBookings.vue';
import ManageAudits from './views/ManageAudits.vue';
import AuditDetail from './views/AuditDetail.vue';
import BookingDetail from './views/BookingDetail.vue';
import IssueTickets from './views/IssueTickets.vue';
import IssueDetail from './views/IssueDetail.vue';
import Vendors from './views/Vendors.vue';
import AddVendors from './views/AddVendors.vue';
import FAQ from './views/FAQ.vue';
import ServiceCategory from './views/ServiceCategory.vue';
import ManageServices from './views/ManageServices.vue';
import ManageReviews from './views/ManageReviews.vue';
import AddService from './views/AddService.vue';
import ViewService from './views/ViewService.vue';
import ManagePayIn from './views/ManagePayIn.vue';
import ManageUsers from './views/ManageUsers.vue';
import ManagePayOuts from './views/ManagePayOuts.vue';

Vue.use(Router)

var routesObj = {
  "service-category": "service_category",
  "add-service": "manage_services",
  "update-service": "manage_services",
  "service": "manage_services",
  "manage-services": "manage_services",

  "service-packages": "packages",

  "audits-detail": "audits",
  "service-audits": "audits",

  "booking-detail": "bookings",
  "service-bookings": "bookings",

  "faq": "faqs",

  "issue-detail": "issue_tickets",
  "issue-tickets": "issue_tickets",

  "add-vendor": "vendors",
  "update-vendor": "vendors",
  "vendors": "vendors",

  "payin": "pay_ins",
  "payouts": "pay_outs",

  "manage-users": "manage_users"
}

var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/about',
      name: 'about',
      component: () => import( /* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: ChangePassword
    }, ,
    {
      path: '/reset-password/:uid/:token',
      name: 'reset-password',
      component: ResetPassword
    },
    {
      path: '/app',
      component: Layout,
      children: [{
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
        }, {
          path: 'sub-admin',
          name: 'sub-admin',
          component: SubAdmins,
        }, {
          path: 'service-category',
          name: 'service-category',
          component: ServiceCategory,
        }, {
          path: 'manage-services',
          name: 'manage-services',
          component: ManageServices,
        },
        {
          path: 'service/:id',
          name: 'service',
          component: ViewService,
        }, {
          path: 'add-service',
          name: 'add-service',
          component: AddService,
        }, {
          path: 'update-service/:id',
          name: 'update-service',
          component: AddService,
        }, {
          path: 'service-packages',
          name: 'service-packages',
          component: ManagePackages,
        }, {
          path: 'service-bookings',
          name: 'service-bookings',
          component: ManageBookings,
        }, {
          path: 'booking-detail/:id',
          name: 'booking-detail',
          component: BookingDetail,
        }, {
          path: 'reviews',
          name: 'reviews',
          component: ManageReviews,
        }, {
          path: 'vendors',
          name: 'vendors',
          component: Vendors,
        }, {
          path: 'add-vendor',
          name: 'add-vendor',
          component: AddVendors,
        }, {
          path: 'update-vendor/:id',
          name: 'update-vendor',
          component: AddVendors,
        }, {
          path: 'service-audits',
          name: 'service-audits',
          component: ManageAudits,
        }, {
          path: 'audits-detail/:id',
          name: 'audits-detail',
          component: AuditDetail,
        }, {
          path: 'faq',
          name: 'faq',
          component: FAQ,
        }, {
          path: 'issue-tickets',
          name: 'issue-tickets',
          component: IssueTickets,
        }, {
          path: 'issue-detail/:id',
          name: 'issue-detail',
          component: IssueDetail,
        }, {
          path: 'payin',
          name: 'payin',
          component: ManagePayIn,
        }, {
          path: 'manage-users',
          name: 'manage-users',
          component: ManageUsers,
        }, {
          path: 'payouts',
          name: 'payouts',
          component: ManagePayOuts,
        }, {
          path: '',
          redirect: {
            name: 'dashboard'
          }
        }
      ]
    },
    {
      path: '',
      redirect: {
        name: '/app/dashboard'
      }
    }
  ]
});

router.afterEach((to, from) => {
  setTimeout(() => {
    $('form').off('keypress').on('keypress', function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        console.log("Enter key pressed");
        e.preventDefault();
        return false;
      }
    });

    // if ($('.navbar-toggler i').text() == "radio_button_checked") {
    //   $("#main").removeClass("main-full");
    // } else {
    //   $("#main").addClass("main-full");
    // }
    // $(".dropdown-trigger").dropdown();

    // Commom, Translation
    $(".dropdown-button").dropdown({
      inDuration: 300,
      outDuration: 225,
      constrainWidth: false,
      hover: true,
      gutter: 0,
      coverTrigger: true,
      alignment: "left"
      // stopPropagation: false
    });

    // Notification, Profile, Translation, Settings Dropdown & Horizontal Dropdown
    $(".notification-button, .profile-button, .translation-button, .dropdown-settings, .dropdown-menu").dropdown({
      inDuration: 300,
      outDuration: 225,
      constrainWidth: false,
      hover: false,
      gutter: 0,
      coverTrigger: false,
      alignment: "right"
      // stopPropagation: false
    });
    // $(".nav-collapsible .navbar-toggler").off().on('click', function () {
    //   // Toggle navigation expan and collapse on radio click
    //   if ($(".sidenav-main").hasClass("nav-expanded") && !$(".sidenav-main").hasClass("nav-lock")) {
    //     $(".sidenav-main").toggleClass("nav-expanded");
    //     $("#main").toggleClass("main-full");
    //   } else {
    //     $("#main").toggleClass("main-full");
    //   }
    //   // Set navigation lock / unlock with radio icon
    //   if (
    //     $(this)
    //     .children()
    //     .text() == "radio_button_unchecked"
    //   ) {
    //     $(this)
    //       .children()
    //       .text("radio_button_checked");
    //     $(".sidenav-main").addClass("nav-lock");
    //     $(".navbar .nav-collapsible").addClass("sideNav-lock");
    //   } else {
    //     $(this)
    //       .children()
    //       .text("radio_button_unchecked");
    //     $(".sidenav-main").removeClass("nav-lock");
    //     $(".navbar .nav-collapsible").removeClass("sideNav-lock");
    //   }
    // });

    // // Expand navigation on mouseenter event
    // $(".sidenav-main.nav-collapsible, .navbar .brand-sidebar").on('mouseenter', function () {
    //   if (!$(".sidenav-main.nav-collapsible").hasClass("nav-lock")) {
    //     $(".sidenav-main.nav-collapsible, .navbar .nav-collapsible")
    //       .addClass("nav-expanded")
    //       .removeClass("nav-collapsed");
    //     $("#slide-out > li.close > a")
    //       .parent()
    //       .addClass("open")
    //       .removeClass("close");

    //     setTimeout(function () {
    //       // Open only if collapsible have the children
    //       if ($(".collapsible .open").children().length > 1) {
    //         $(".collapsible").collapsible("open", $(".collapsible .open").index());
    //       }
    //     }, 100);
    //   }
    // });

    // // Collapse navigation on mouseleave event
    // $(".sidenav-main.nav-collapsible, .navbar .brand-sidebar").on('mouseleave', function () {
    //   if (!$(".sidenav-main.nav-collapsible").hasClass("nav-lock")) {
    //     var openLength = $(".collapsible .open").children().length;
    //     $(".sidenav-main.nav-collapsible, .navbar .nav-collapsible")
    //       .addClass("nav-collapsed")
    //       .removeClass("nav-expanded");
    //     $("#slide-out > li.open > a")
    //       .parent()
    //       .addClass("close")
    //       .removeClass("open");
    //     setTimeout(function () {
    //       // Open only if collapsible have the children
    //       if (openLength > 1) {
    //         $(".collapsible").collapsible("close", $(".collapsible .close").index());
    //       }
    //     }, 100);
    //   }
    // });
    if (to.path.indexOf('app/') >= 0 && to.name != 'add-vendor' && to.name != 'update-vendor') {
      $('#slide-out').animate({
        scrollTop: $('#slide-out li.active').offset().top - 64
      });
    }
  }, 400);
  setTimeout(() => {
    $('input').attr('autocomplete', "off");
  }, 1000);
});

// router.beforeEach((to, from, next) => {
//   if (localStorage.homecare_admin_auth) {
//     if (to.name == "change-password") {
//       next();
//       return;
//     }
//     let userDetails = JSON.parse(localStorage.homecare_admin_auth),localPermission = JSON.parse(localStorage.getItem('homecare_admin_permissions'));
//     let permissions = (localPermission != null && localPermission  != undefined) ?  localPermission : userDetails.permissions;
//     var routesObj = {
//       "login": "login",
//       "dashboard": "dashboard",

//       "service-category": "service_category",
//       "add-service": "manage_services",
//       "update-service": "manage_services",
//       "service": "manage_services",
//       "manage-services": "manage_services",

//       "service-packages": "packages",

//       "audits-detail": "audits",
//       "service-audits": "audits",

//       "booking-detail": "bookings",
//       "service-bookings": "bookings",

//       "faq": "faqs",

//       "issue-detail": "issue_tickets",
//       "issue-tickets": "issue_tickets",

//       "add-vendor": "vendors",
//       "update-vendor": "vendors",
//       "vendors": "vendors",

//       "payin": "pay_ins",
//       "payouts": "pay_outs",

//       "manage-users": "manage_users"
//     }

//     if (userDetails.persona == "superuser" && permissions.length == 0) {
//       next();
//     }
//     else {
//       let routeName = routesObj[to.name];

//       if (Array.isArray(permissions)) {
//         if (permissions.indexOf(routeName) == -1) {
//           if (permissions.indexOf(to.name) >= 0) {
//             next(to.fullPath);
//           }
//           else {
//             // console.log(to.fullPath,`/app/${permissions[0].key}`)
//             next()
//             // next({
//             //   path: `/app/${permissions[0].key}`
//             // });
//             // return;
//           }
//         } 
//         else {
//           next();
//         }
//       }
//       else {
//         next();
//       }
//     }
//   }
//   else {
//     if (to.name == null) {
//       next('/login');
//     } else if (to.name == 'login') {
//       next();
//     } 
//     else {
//       next();
//     }
//   }
// })

router.beforeEach((to, from, next) => {
  if (localStorage.homecare_admin_auth && JSON.parse(localStorage.homecare_admin_auth).persona == 'sub_admin') {
    let permissions = ''
    if(localStorage.homecare_admin_permissions && JSON.parse(localStorage.getItem('homecare_admin_permissions')).map((a) => a.key))
      permissions = JSON.parse(localStorage.getItem('homecare_admin_permissions')).map((a) => a.key)
    // console.log(permissions,to)
    if (permissions.includes(to.name))
      next()
    else{
      next()
    }
  } else {
    next()
  }
})


export default router;